import { jsxs, jsx } from "react/jsx-runtime";
const IconCriticalSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 22.997a2.977 2.977 0 0 1-2.121-.877h-.001L1.88 14.121c-.566-.564-.877-1.317-.877-2.121s.311-1.557.877-2.122L9.879 1.88c1.129-1.131 3.112-1.131 4.243 0l7.998 7.999c.566.564.877 1.317.877 2.121s-.311 1.557-.877 2.122l-7.999 7.998a2.975 2.975 0 0 1-2.121.877Zm0-19.994a.988.988 0 0 0-.706.29l-8 8c-.188.187-.291.438-.291.707s.103.52.291.706l7.999 8h.001c.373.375 1.039.375 1.412 0l8-7.999c.188-.187.291-.438.291-.707s-.103-.52-.29-.706l-8-8A.992.992 0 0 0 12 3.003Z" }),
      /* @__PURE__ */ jsx("circle", { cx: 12, cy: 16, r: 1 }),
      /* @__PURE__ */ jsx("path", { d: "M11.978 13a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1Z" })
    ]
  }
);
export {
  IconCriticalSvg
};
